











































































import SimpleMap from '../../core/components/SimpleMap.vue';
import ModalUploadCSV from './ModalUploadCSV.vue';

import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getDateFromTimestamp,
    getIdsFromList,
    removeItemsFromList,
    matchedIndexIdInArray,
    getUniqueId,
    formatDate,
    downloadFile,
    getDateFromDateFormatApi
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Button from '../../core/components/Button.vue';
import {
    booleanFormatter,
    formattedDate,
    getOnlyDateFromTimestamp,
    nullFormatter
} from '../../core/utils/table-formatters';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import ModalManualFactor from './ModalManualFactor.vue';
import ModalVehicleCalibration from './ModalVehicleCalibration.vue';
import { config } from 'rxjs';
import moment from 'moment';
import { set } from 'tiny-cookie';

@Component({
    components: {
        Loading,
        Combobox,
        SimpleMap,
        DatePickerSingle,
        DatePickerRange,
        Button,
        SimpleTable,
        ModalManualFactor,
        DeleteConfirmation,
        ModalUploadCSV
    }
})
export default class CardLevMapa extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({
        default() {
            return [];
        }
    })
    items: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    harvestList: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    vehicleVariables: Array<object>;
    @Prop({ default: false }) isSowing: boolean;
    @Prop({ default: false }) seeAll: boolean;
    @Prop({ default: -1 }) vehicleID: number;
    @Prop({ default: true }) canUpload: boolean;
    @Prop({ default: true }) canDelete: boolean;
    @Prop({ default: 'Levantada de Mapas' }) cardTitle: string;
    @Prop({ default: false }) disabledRow: boolean;
    patchSetting: object | null = {};
    manualFactorToDelete: object | null = null;
    loadingLevMap: boolean = false;
    loadingTable: boolean = false;
    viewAllType: string = '';
    levMapToDelete: object = {};
    visibleModalSettings: boolean = false;
    loadingSettings: boolean = false;
    deleteType: string = '';
    visibleModalCSV: boolean = false;
    headersLevMap: Array<object> = [
        {
            text: 'Fecha ult levantada',
            align: 'left',
            value: 'upload_date',
            formatter: this.dateFormatter
        },
        {
            text: 'Cosecha',
            align: 'center',
            value: 'harvest.name'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions'
        }
    ];

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    visibilityModalCSV(value) {
        this.visibleModalCSV = value;
    }

    variableFormatter(item) {
        if (item !== null) {
            let varDescription = item['description'] !== null ? item['description'] : '';
            return item['variable_id'] + ' - ' + varDescription;
        } else {
            return '-';
        }
    }

    visibleModalViewAll: boolean = false;

    //delete confirmation
    confirmationDelete: boolean = false;
    loadingIgnoredPeriods: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';

    @Emit()
    disabledRowAction(item) {
        return item;
    }

    deleteLevMap(levMapToDelete) {
        this.levMapToDelete = levMapToDelete;
        this.setDeleteType('levmap');
        this.showDeleteConfirmationDialog('Eliminar Levantada de Mapa', '¿Está seguro que desea eliminar este CSV?');
    }

    deleteConfiguration(levMapToDelete) {
        this.levMapToDelete = levMapToDelete;
        this.setDeleteType('levmap');
        this.showDeleteConfirmationDialog('Eliminar Levantada de Mapa', '¿Está seguro que desea eliminar este CSV?');
    }

    downloadLevMap(item) {
        this.$set(item, 'isDownloading', true);
        let csvUrl = item['url'];
        InsuranceServices.getArrayBufferFromUrl(csvUrl)
            .then(res => {
                this.$set(item, 'isDownloading', false);
                let actualHour = moment().format('DD-MM-YYYY_HH:mm');
                let company =
                    item['harvest'] && item['harvest']['company'] && item['harvest']['company']['name']
                        ? item['harvest']['company']['name']
                        : null;
                if (company == null) {
                    company = item['harvest']['name'];
                } else {
                    company += '_' + item['harvest']['name'];
                }
                let fileName = company + '_' + 'performance_map' + '_' + actualHour + '.csv';
                downloadFile(fileName, res);
            })
            .catch(err => {
                this.$set(item, 'isDownloading', false);
            });
    }

    setDeleteType(value) {
        this.deleteType = value;
    }

    pendingTable(value) {
        this.loadingTable = value;
    }

    @Emit()
    addNewManualFactorToList(item) {
        return item;
    }

    @Emit()
    viewAllLevMap(item) {}

    @Emit()
    newItemsList(list) {
        return list;
    }

    @Emit()
    reloadViewAllModalDetail() {}

    @Emit()
    reloadPreviousList() {}

    visibilityModalViewAll(value) {
        this.visibleModalViewAll = value;
    }

    @Emit()
    updateManualFactorInList(item) {
        return item;
    }

    visibilityModalSettings(value) {
        this.visibleModalSettings = value;
    }

    // closeModalManualFactor() {
    //     this.patchSetting = null;
    //     this.manualFactorToDelete = null;
    //     this.visibilityModalSettings(false);
    // }

    clickAddNewSetting() {
        this.visibilityModalSettings(true);
        this.patchSetting = null;
    }

    addNewCSV(newLevMapList) {
        this.items = [];
        this.loadingLevMap = true;

        setTimeout(() => {
            this.assignLevMapItems(newLevMapList);
            this.reloadPreviousList();
            this.loadingLevMap = false;
        }, 200);
    }

    assignLevMapItems(items) {
        for (let index = 0; index < items.length; index++) {
            const item = items[index];
            let companyName = item['harvest']['company']['name'];
            let harvestName = companyName + ' - ' + item['harvest']['name'];
            this.$set(item['harvest'], 'name', harvestName);
        }
        this.newItemsList(items);
    }

    editManualFactor(item) {
        this.patchSetting = item;
        this.visibilityModalSettings(true);
    }

    deleteManualFactor(item) {
        this.manualFactorToDelete = item;

        this.showDeleteConfirmationDialog(
            'Eliminar factor manual',
            '¿Está seguro que desea eliminar este factor manual'
        );
    }

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            this.removeLevMap();
        } else {
            this.confirmationDelete = false;
        }
    }

    removeLevMap() {
        let self = this;
        this.loadingLevMap = true;
        InsuranceServices.deleteLevMap(this.levMapToDelete['id'])
            .then(response => {
                let msg = '';
                if (response && response.data && response.data.message) {
                    msg = response.data.message;
                } else {
                    msg = 'CSV eliminado con exito';
                }
                self.$_successDeleteRecipients(msg);
                self.assignLevMapItems(removeItemsFromList(self.items, [self.levMapToDelete], 'id'));
                self.loadingLevMap = false;
                self.reloadPreviousList();
                self.reloadViewAllModalDetail();
            })
            .catch(error => {
                this.showMsgError(error);
                self.loadingLevMap = false;
            });
    }

    showMsgError(error) {
        let self = this;
        let msg = '';
        if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message;
        } else {
            msg = 'Ocurrió un error';
        }
        this.$_errorAddFilter(msg);
    }

    showDeleteConfirmationDialog(title, msgBody) {
        this.deleteModalTitle = title;
        this.deleteBody = msgBody;
        this.confirmationDelete = true;
    }

    dateFormatter(value) {
        return formattedDate(value);
    }

    formatBoolean(value) {
        return booleanFormatter(value);
    }
}
